import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import HeaderComponent from '../components/General/HeaderComponent';
import MenuBarComponent from '../components/Panel/MenuBarComponent';
import PanelHpComponent from '../components/Panel/PanelHpComponent';
import TeamComponent from '../components/Panel/TeamComponent';
import TimelineComponent from '../components/Panel/TimelineComponent';
import TaskComponent from '../components/Panel/TaskComponent';
import KanbanComponent from '../components/Panel/KanbanComponent';
import FinancialComponent from '../components/Panel/FinancialComponent';
import PAsideComponent from '../components/Panel/PAsideComponent';
import PAside2Component from '../components/Panel/PAsideTwoComponent';
import ProjectToolsComponent from '../components/Panel/ProjectToolsComponent';
import { getProjectsDash } from '../services/projects';

export default function ProjectDetail() {
  const { id } = useParams();
  const location = useLocation();
  const [projectData, setProjectData] = useState({
    pname: 'Proje Adı',
    pdesc: 'Proje açıklaması yükleniyor...',
    pstatus: 1,
    pfirm: 'Firma Adı'
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // URL'e göre aktif tab'ı belirle
  const getActiveTab = () => {
    const path = location.pathname;
    if (path.includes('/team')) return 'team';
    //if (path.includes('/timeline')) return 'timeline';
    if (path.includes('/tasks')) return 'tasks';
    if (path.includes('/kanban')) return 'kanban';
    if (path.includes('/financials')) return 'financials';
    return 'prodash';
  };
  
  const activeTab = getActiveTab();

  useEffect(() => {
    async function fetchProjectData() {
      try {
        setLoading(true);
        setError(null);
        
        // Proje detay ve istatistik bilgilerini getir
        const projectResponse = await getProjectsDash({ slug: id });
        
        // Veri yapısını düzenle - projectData içindeki veriyi ana seviyeye çıkar
        const processedData = {
          ...projectResponse?.projectData, // Proje bilgilerini ana seviyeye çıkar
          projectStats: projectResponse?.projectStats,
          projectsUsers: projectResponse?.projectsUsers,
          timelineData: projectResponse?.timelineData,
          userstatus: projectResponse?.userstatus,
          organization: projectResponse?.organization || null
        };
        
        setProjectData(processedData);
        
      } catch (error) {
        setError('Proje bilgileri yüklenirken bir hata oluştu.');
        
        // Hata durumunda fallback data
        setProjectData({
          pname: `Proje ${id}`,
          pdesc: 'Proje bilgileri yüklenemedi.',
          pstatus: 1,
          pfirm: 'Bilinmeyen Firma',
          created_at: new Date().toISOString().split('T')[0],
          penddate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
          pbudget: '₺0'
        });
      } finally {
        setLoading(false);
      }
    }

    if (id) {
      fetchProjectData();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="w-full h-screen flex justify-center items-center dark:bg-dark-100">
        <img src="/assets/penalogo.svg" alt="Yükleniyor..." width="200" height="200" className="animate-pulse" />
      </div>
    );
  }

  // Error handling
  if (error) {
    return (
      <div className="w-full h-screen flex justify-center items-center dark:bg-dark-100">
        <div className="text-center">
          <img src="/assets/penalogo.svg" alt="Hata" width="100" height="100" className="mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-darkWhite-300 mb-2">Hata Oluştu</h2>
          <p className="text-gray-600 dark:text-darkWhite-100">{error}</p>
        </div>
      </div>
    );
  }

  const renderTabContent = () => {
    switch (activeTab) {
      case 'team':
        return <TeamComponent projectId={id} />;
      //case 'timeline':
      // return <TimelineComponent projectId={id} />;
      case 'tasks':
        return <TaskComponent projectId={id} />;
      case 'kanban':
        return <KanbanComponent projectId={id} />;
      case 'financials':
        return <FinancialComponent projectId={id} />;
      default:
        return (
          <div className="flex flex-col lg:flex-row gap-4">
            <div className="lg:basis-3/4 w-full">
              <PanelHpComponent 
                projectData={projectData}
                projectId={id}
                usersData={projectData?.projectsUsers}
               // timelineData={projectData?.timelineData}
              />
            </div>
            <div className="lg:basis-1/4 w-full mt-3">
              <ProjectToolsComponent projectId={id} />
            </div>
          </div>
        );
    }
  };

  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title={projectData.pname || `Proje ${id}`} />
        <MenuBarComponent title={activeTab} />
        {renderTabContent()}
      </div>
    </div>
  );
}
